import React from 'react'
import { Switch, Route } from 'react-router-dom'

import { Contract } from '.'
import { CreateContract } from './CreateContract'
import { EditContract } from './EditContract'

export const ContractBootstrap: React.FC = () => {
  return (
    <Switch>
      <Route
        path="/hr/persons/contracts/:personUuid"
        exact
        component={Contract}
      />
      <Route
        path="/hr/persons/contracts/:personUuid/create"
        component={CreateContract}
      />
      <Route
        path="/hr/persons/contracts/:personUuid/edit/:contractUuid"
        component={EditContract}
      />
    </Switch>
  )
}
